<template>
  <Toast />
  <Message v-if="!service_enabled" severity="warn">Mail service is disabled for this domain</Message>
  <Breadcrumb :home="bc_home" :model="bc_items" />
  <MailNavBar />
  
  <Card v-if="MailAccounts" class="">
      <template #title>
        <Button icon="pi pi-plus" class="p-button-rounded p-button-primary" @click="openNewAccountModal" />
      </template>
        <template #content>
          
            <DataTable :value="MailAccounts.accounts" class="p-datatable-sm" responsiveLayout="stack" @row-click="openAccountModal($event)" rowHover stripedRows selectionMode="single">
                <template #empty>
                  <div style="text-align: center;">No accounts found</div>
                </template>
                <Column field="address" header="Account"></Column>
                <Column field="name" header="Name"></Column>
                <Column header="Active" headerStyle="width: 100px; text-align: right">
                  <template #body="slotProps">
                    <i v-if="slotProps.data.is_enabled" style="color:var(--green-400)" class="pi pi-check-circle"></i>
                    <i v-else style="color:var(--orange-400)" class="pi pi-minus-circle"></i>
                  </template>
                </Column>
            </DataTable>
        </template>
  </Card>
  
  <Dialog header="New Account" v-model:visible="displayNewAccountModal" :modal="true">
      <div class="new-account">
          <form class="p-fluid" autocomplete="off" v-on:submit.prevent>
              <input autocomplete="off" name="hidden" type="text" style="display:none;">
              <input autocomplete="off" name="hidden1" type="text" style="display:none;">
              <input autocomplete="off" name="hidden2" type="text" style="display:none;">
              <div class="p-field">
                  <div class="p-float-label">
                      <InputText id="n34584658" v-model="account.address" autocomplete="off" autofocus />
                      <label for="n34584658">Login *</label>
                      <small class="p-error" v-if="errors.address">{{ errors.address }}</small>
                  </div>
              </div>
              <div class="p-field">
                  <div class="p-float-label">
                      <InputText id="name" v-model="account.name" autocomplete="off" />
                      <label for="name">Real Name</label>
                  </div>
              </div>
              <div class="p-field">
                  <div class="p-float-label">
                      <Password id="p3453453" v-model="account.password" autocomplete="new-password" toggleMask v-on:keyup.enter="createAccount"/>
                      <label for="p3453453">Password *</label>
                      <small class="p-error" v-if="errors.password">{{ errors.password }}</small>
                  </div>
              </div>
              <!--<div class="p-field">
                  <div class="p-float-label">
                      <Dropdown id="domain" v-model="account.domain_id" :options="Domains.domains" optionLabel="name" optionValue="id" />    
                      <label for="domain">Domain *</label>
                  </div>
              </div>-->
              <div class="p-field-checkbox">
                  <Checkbox id="is_enabled" :binary="true" v-model="account.is_enabled"></Checkbox>
                  <label for="is_enabled">Active</label>
              </div>
              
          </form>
      </div>
      <template #footer>
        <Button label="Create" icon="pi pi-check-square" class="w-full" :loading="loading" @click="createAccount"></Button>
      </template>
  </Dialog>
  <Dialog :header="account.address" v-model:visible="displayAccountModal" :modal="true">
      <div class="new-account">
          <form class="p-fluid" autocomplete="off" v-on:submit.prevent>
              <input autocomplete="off" name="hidden" type="text" style="display:none;">
              <input autocomplete="off" name="hidden1" type="text" style="display:none;">
              <input autocomplete="off" name="hidden2" type="text" style="display:none;">
              <div class="p-field">
                  <div class="p-float-label">
                      <InputText id="n34584658" v-model="account.name" autocomplete="off" v-on:keyup.enter="saveAccount" />
                      <label for="n34584658">Real Name</label>
                  </div>
              </div>
              <div class="p-field">
                  <div class="p-float-label">
                      <Password id="p3453453" v-model="account.password" autocomplete="new-password" toggleMask v-on:keyup.enter="saveAccount"/>
                      <label for="p3453453">Password *</label>
                      <small class="p-error" v-if="errors.password">{{ errors.password }}</small>
                  </div>
              </div>
              <div class="p-field-checkbox">
                  <Checkbox id="is_enabled" :binary="true" v-model="account.is_enabled"></Checkbox>
                  <label for="is_enabled">Active</label>
              </div>
          </form>
      </div>
      <template #footer>
          <Button label="Delete" class="p-button-text p-button-danger" @click="deleteAccount(account)"></Button>
          <Button label="Update" icon="pi pi-check-square" :loading="loading" @click="saveAccount"></Button>
      </template>
  </Dialog>
  <ConfirmDialog></ConfirmDialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getAttributes } from "../helpers/attributes.js"
import { convertErrors } from "../helpers/errors.js"
import MailNavBar from '../components/MailNavBar.vue'

export default {
  name: 'MailAccounts',
  components: {
    MailNavBar
  },
  data () {
    return {
      account: {
        id: '',
        address: '',
        password: '',
        is_enabled: true
      },
      domain_name: 'test_domain',
      errors: {},
      displayAccountModal: false,
      displayNewAccountModal: false,
      domains: [],
      selectedDomain: null,
      loading: false,
      bc_home: {icon: 'pi pi-home', to: '/domains'},
      bc_items: [
          {icon: 'pi pi-spin pi-spinner'},
          {label: 'Mail', to: '/domains/'+this.$route.params.domain_id+'/mail'},
          {label: 'Accounts'}
      ],
      service_enabled: true,
    }
  },
  created: function () {
  //  // a function to call getposts action
    //this.GetDomains()
    this.GetMailAccounts(this.$route.params.domain_id)


    //console.log(this.GetDomainById2(this.$route.params.domain_id))
    //Object.assign(this.domain_name, domain.name)
    //this.GetDomains()
  },
  //created() {
  //  this.$watch(
  //    () => this.$route.params,
  //    (toParams, previousParams) => {
  //      console.log(toParams, previousParams)
  //      // react to route changes...
  //    }
  //  )
  //},
  computed: {
    ...mapGetters({ MailAccounts: 'StateMailAccounts', Domains: 'StateDomains' }),
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    current_domain() {
      return this.MailAccounts
    }
  },
  watch: {
    current_domain (d) {
      if (d.domain && d.domain.name.length) {
        this.domain_name = d.domain.name
        this.bc_items = [
          {label: d.domain.name, to: '/domains/'+this.$route.params.domain_id},
          {label: 'Mail', to: '/domains/'+this.$route.params.domain_id+'/mail'},
          {label: 'Accounts'}
        ]

        const services = getAttributes(d.domain.attributes, 'services')

        if (services && services.mail && services.mail.enabled) {
          this.service_enabled = true
        }
        else {
          this.service_enabled = false 
        }
      }
    },
  },
  methods: {
    ...mapActions(['CreateMailAccount', 'GetMailAccounts', 'UpdateMailAccount', 'DeleteMailAccount', 'GetDomains', 'GetDomainById']),
    async createAccount () {
      this.loading = true
      this.errors = {}
      
      this.account.domain_id = this.$route.params.domain_id

      this.CreateMailAccount(this.account)
        .then(response => {
          this.displayNewAccountModal = false
          this.account = {id: '', address: '', password: '', is_enabled: true}
          this.$toast.add({severity:'success', summary: 'Account created', detail:response.data.address, life: 3000});
        })
        .catch(error => {
          this.errors = convertErrors(error.response.data)
        })
        .finally(() => this.loading = false)
    },
    async saveAccount () {
      this.loading = true
      this.errors = {}
      
      this.UpdateMailAccount(this.account)
        .then(response => {
          this.displayAccountModal = false
          this.account = {id: '', address: '', password: '', is_enabled: true}
          this.$toast.add({severity:'success', summary: 'Account updated', detail:response.data.address, life: 3000});
        })
        .catch(error => {
          this.errors = convertErrors(error.response.data)
        })
        .finally(() => this.loading = false)
    },
    async deleteAccount(account) {
      this.errors = {}
      
      this.$confirm.require({
          message: 'Are you sure you want to delete ' + account.address + '?',
          header: 'Confirmation',
          icon: 'pi pi-exclamation-triangle',
          acceptClass: 'p-button-danger',
          accept: () => {
            this.loading = true

            this.DeleteMailAccount(account)
              .then(response => {
                this.displayAccountModal = false
                this.$toast.add({severity:'info', summary: 'Account deleted', life: 3000});
              })
              .catch(error => {
                this.errors = error.response.data.errors
              })
              .finally(() => this.loading = false)
          },
          reject: () => {
              //callback to execute when user rejects the action
          }
      });


    },
    openNewAccountModal() {
      this.errors = {}
      this.account = {id: '', address: '', password: '', is_enabled: true}
      this.displayNewAccountModal = true
    },
    openAccountModal(e) {
      this.errors = {}
      const result = this.MailAccounts.accounts.find( ({ id }) => id === e.data.id );
      Object.assign(this.account, result)
      this.displayAccountModal = true
    }
  }
}
</script>

<style lang="scss" scoped>
.new-account {
        form {
            margin-top: 2rem;
        }

        .p-field {
            margin-bottom: 1.5rem;
        }


}
</style>